import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nav-toggler.svg",
  "use": "nav-toggler.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"nav-toggler.svg\"><g fill=\"currentColor\"><rect x=\"2\" y=\"5\" width=\"20\" height=\"2\" rx=\"1\" /><rect x=\"2\" y=\"11\" width=\"20\" height=\"2\" rx=\"1\" /><rect x=\"2\" y=\"17\" width=\"20\" height=\"2\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol